<template>
  <div class="multi-select-dropdown">
    <van-field
      readonly
      clickable
      :label="label"
      :placeholder="placeholder"
      :value="selectedText"
      @click="openDropDown"
      :disabled="disabled"
    >
      <template #right-icon>
        <van-icon :name="dropDownOpened ? 'arrow-up' : 'arrow'" />
      </template>
    </van-field>

    <van-popup
      v-model="dropDownOpened"
      :style="{ maxHeight: maxHeight + 'px'}"
      round
      position="bottom"
      :transition="transition"
    >
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="onCancel">取消</button>
        <button type="button" class="van-picker__confirm" @click="onConfirm">确认</button>
      </div>
      <van-checkbox-group v-model="selectedValues" style="line-height: 100px;text-align: center;margin:auto;width: 20%;height: 300px;">
        <van-cell-group inset>
          <van-cell
            v-for="(item, index) in options"
            clickable
            :key="item"
            :title="item"
            style="margin-right: 120px;"
            center 
            @click="toggle(index)"
          >
            <template #right-icon>
              <van-checkbox
                :name="item"
                ref="checkboxes"
                @click.stop
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
  </div>
</template>

<style scoped>
  .multi-select-dropdown {
    position:relative;
  }
  .van-popup-c {
    border-radius: 16px 16px 0 0;
    width: 100%;
  }
  .van-popup--bottom .van-popup__content {
    padding: 10px;
  }
  .van-checkbox {
    margin-right: 20px;
  }
  
  .van-checkbox + .van-checkbox {
    margin-left: 20px;
  }
  .van-cell:after {
    border: none;
  }
  [class*="van-hairline"]::after {
    border: none;
  }
</style>

<script>
import { ref, onBeforeUpdate } from 'vue';
  export default {
    name:'SelectMultiple',
    props: {
      label: String,
      placeholder: String,
      model: String,
      options: {
        type: Array,
        required: true,
        default: () => [],
      },
      value: {
        type: [String, Number, Array],
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      maxHeight: {
        type: Number,
        default: 500,
      },
      transition: {
        type: String,
        default: "van-fade",
      },
      confirmButtonText: {
        type: String,
        default: "确定",
      },
      multiple: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        selectedValues: Array.isArray(this.value) ? this.value : this.value ? [this.value] : [],
        dropDownOpened: false,
        checked: [],
        checkboxRefs: []
      };
    },
    computed: {
      selectedText() {
        if (this.selectedValues.length) {
          return this.selectedValues.map((value) => {
            let selectedItem = this.options.find((item) => item === value);
            return selectedItem ? selectedItem : "";
          }).join(", ");
        } else {
          return "";
        }
      },
    },
    methods: {
      toggle (index)  {
        this.$refs.checkboxes[index].toggle();
      },
      openDropDown() {
        if (!this.disabled) {
          this.dropDownOpened = true;
        }
      },
      onCancel() {
        this.dropDownOpened = false;
        this.selectedValues = []
      },
      onConfirm () {
        this.$emit("input", this.selectedValues);
        this.$emit("change", this.selectedValues);
        this.dropDownOpened = false;
      }
    },
  };
</script>